import { useFormContext } from "react-hook-form";
import axios from "axios";
import { TextInput } from "react-admin";

// Campo de CEP que consulta o ViaCEP e preenche o bloco de endereço
// correspondente — `commercial` alterna entre o endereço pessoal e o
// comercial (mesmos campos, prefixo diferente).
//
// Cuidados que a versão anterior não tinha:
// - só consulta com o CEP completo (8 dígitos; antes disparava com 7);
// - envia só os dígitos na URL (aceitava hífen/lixo);
// - ignora a resposta {erro: true} do ViaCEP — CEP inexistente
//   sobrescrevia com vazio os campos já preenchidos.
export const ZIPComponent = ({
  commercial = false,
}: {
  commercial?: boolean;
}) => {
  const { setValue } = useFormContext();
  const prefix = commercial ? "commercialAddress" : "address";

  const fetchCep = async (digits: string) => {
    try {
      const response = await axios.get(`//viacep.com.br/ws/${digits}/json`);
      const { data } = response;
      // CEP inexistente: ViaCEP devolve 200 com {erro: true}
      if (!data || data.erro) return;
      setValue(`${prefix}State`, data.uf);
      setValue(`${prefix}City`, data.localidade);
      setValue(`${prefix}Neighborhood`, data.bairro);
      // o campo do logradouro é o próprio prefixo (address /
      // commercialAddress)
      setValue(prefix, data.logradouro);
    } catch (error) {
      console.error("Erro ao buscar CEP: ", error);
    }
  };

  // exibe 00000-000 quando o valor é um CEP completo
  const formatZipCode = (v: string) => {
    if (!v) return v;
    const cleaned = v.replace(/\D/g, "");
    const match = cleaned.match(/^(\d{5})(\d{3})$/);
    return match ? `${match[1]}-${match[2]}` : v;
  };

  return (
    <TextInput
      source={`${prefix}ZipCode`}
      label={commercial ? "CEP Comercial" : "CEP"}
      fullWidth
      onChange={(e) => {
        const digits = String(e.target.value || "").replace(/\D/g, "");
        if (digits.length === 8) fetchCep(digits);
      }}
      helperText={false}
      format={(v: any) => formatZipCode(v)}
    />
  );
};
